import { render, staticRenderFns } from "./Express.vue?vue&type=template&id=ff86462a"
import script from "./Express.vue?vue&type=script&lang=ts"
export * from "./Express.vue?vue&type=script&lang=ts"
import style0 from "./Express.vue?vue&type=style&index=0&id=ff86462a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports